import React from 'react';
import { Container } from '@gasbuddy/react-components';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

export default function UnknownPage({ staticContext }) {
  const { t } = useTranslation('miscellaneous');

  staticContext.status = 404;
  return (
    <Container style={{ minHeight: 600, marginTop: 64 }}>
      <h1>{t('unknownPage.title')}</h1>
      <p>{t('unknownPage.message')}</p>
    </Container>
  );
}

UnknownPage.propTypes = {
  staticContext: PropTypes.shape(),
};

UnknownPage.defaultProps = {
  staticContext: {},
};
